var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9981 30.0803C12.9221 30.0803 12.7313 30.0599 12.603 29.8712L10.254 26.4153C9.70161 25.6026 8.93462 24.9669 8.03598 24.5769C3.42221 22.5743 0.473628 18.0304 0.524075 13.0008C0.55733 9.68313 1.86782 6.57718 4.21411 4.25505C6.56015 1.93317 9.68003 0.654297 12.9981 0.654297H12.9982C19.8767 0.654297 25.4728 6.25047 25.4728 13.129C25.4728 18.1058 22.5213 22.6005 17.9533 24.5799C17.0599 24.9671 16.2952 25.6018 15.7422 26.4154L13.3932 29.8712C13.2649 30.0599 13.0742 30.0803 12.9981 30.0803Z",
    fill: "#FF8C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contact-location.729ff4e4c56233981c1233245674dcc1.svg";
export { ForwardRef as ReactComponent };